<template>
    <div class="  con_content">
       
        <div class="container">
            <div class="container_top h_48">权限列表</div>
           
            <!-- table组件 -->
            <div class="my_table">
               
                <div class="my_search">
                    <Row class="search_row">  
                        <div  class="search_name">
                            <!-- 全部显示 -->
                            <!-- <Button class="mR5"    type="primary"   @click='listAllFun'  >{{allShow}}</Button> -->
                            <Button class="mR5"    type="info"    @click='route="/layout/jurisdiction/menu/add";addFun(-1)' > <Icon type="md-add" />添加</Button>
                            <!-- <Button class="mR5"    type="error"    @click='del_num = 1;route="/layout/jurisdiction/menu/del";delFun({})' > <Icon type="md-close" />批量删除</Button> -->
                            
                        </div>    
                    </Row> 
                </div>
            </div>
             <!-- table组件 -->
            <div class="my_table  ">
                <Header class="my_title txt_l">
                    <span class="my_titleL">
                       <Icon class="fw_900 " type="ios-list" size='30'/>     
                        数据列表 
                    </span>
                    
                    <div class="ct_rgt">
                        
                        <!-- <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> -->
                        
                    </div>
                </Header>
                <Table  row-key="guid" style='bottom50'   border :columns="columns1" :data="data1" @on-selection-change="checkFun"  ref='table'>
                   
                    <!-- 图标 -->
                    <template slot-scope="{ row }" slot="menuImage">
                        <div class="demo-avatar">
                            <Icon v-if="row.menuImage == null"  size="20" type="ios-folder-outline" />
                            <Icon v-if="row.menuImage != null"  size="20" :type="row.menuImage" />
                        </div>                           
                    </template>
                    
                    <!-- 按钮 -->
                    <template slot-scope="{ row, index }" slot="changeList">
                        <!-- <Poptip trigger="hover" :title="row.surname" content="展开二级列表"  v-if=' row.level == 0'> -->
                            <Button v-if='row.level == 0' class="padlr5  cWhite" size="small"  @click="listFun(row,index)"  style='background:#22B4F5;'    custom-icon="iconfont icon-sitemap" ></Button>
                            <Button v-else-if='row.level == 1' class="padlr5  cWhite" size="small"  @click="listFun(row,index)"  style='background:#3e95b5;'    custom-icon="iconfont icon-sitemap" ></Button>
                            <Button v-else-if='row.level == 2' class="padlr5  cWhite" size="small"  @click="listFun(row,index)"  style='background:#41ba9f;'    custom-icon="iconfont icon-sitemap" ></Button>
                            <Button v-else class="padlr5  cWhite" size="small"  @click="listFun(row,index)"  style='background:#33CC99;'    custom-icon="iconfont icon-sitemap" ></Button>
                        <!-- </Poptip>   --> 
                    </template>


                    <!-- 按钮 -->
                    <template slot-scope="{ row, index }" slot="btn">
                        <!-- <Poptip trigger="hover" :title="row.surname" content="查看"> -->
                        <Poptip trigger="hover"    content="添加">
                            <Button class="padlr5" size="small"  @click='route="/layout/jurisdiction/menu/add";addFun(row)'   type="info"    icon="md-add"  ></Button>
                        </Poptip>  
                        <Poptip trigger="hover"   content="编辑">
                            <Button class="padlr5" size="small"  @click='route="/layout/jurisdiction/menu/editor";editorFun(row)'  type="success"      icon="md-open"></Button>
                        </Poptip>
                        <Poptip trigger="hover"  content="删除">
                            <Button class="padlr5"  size="small" @click='del_num = 0;route="/layout/jurisdiction/menu/del";delFun(row)'  type="error"      icon="md-close"></Button>
                        </Poptip>
                       
                    </template>
                    
                </Table>
                <div class="h50 "></div>
                
                <!-- 添加弹窗 -->
                <Modal
                    v-model="modal1"
                    title="菜单添加"
                    @on-ok="ok1"
                    @on-cancel="cancel1"
                    class-name="vertical-center-modal"
                >
                    <div slot="footer">
                        <Button type='text' size='large' @click='cancel1'>取消</Button>
                        <Button type='primary' size='large' @click='ok1'>添加</Button>
                    </div>
                    <ul class="list_ul">
                        <!-- 父级 -->
                        <li> 
                            <div class='list_title'> <span class="cRed">*</span> 父级 :</div>
                            <div class="list_con">
                               
                                <Select class="select" v-model="checkGuid2" >
                                    <Option v-for="item in add_select" :value="item.guid" :key="item.guid">{{ item.title }}</Option>
                                </Select>
                                
                            </div>
                        
                        </li>
                        <!-- 权限名称-->
                        <li>
                            <div class='list_title'> <span class="cRed">*</span> 权限名称 :</div> 
                            <div class="list_con">
                                <Input      type='text' class="ipt"  placeholder="请输入权限名称" v-model="model2"   />
                            </div>                                            
                        </li>
                        <!-- 控制器/方法 -->
                        <li>
                            <div class='list_title'> <span class="cRed">*</span> 控制器/方法 :</div> 
                            <div class="list_con">
                                <Input      type='text' class="ipt"  placeholder="请输入控制器/方法" v-model="model3"   />
                            </div>                                            
                        </li>
                        <!-- 图标名称 -->
                        <li>
                            <div class='list_title'>  图标名称 :</div> 
                            <div class="list_con">
                                <Input      type='text' class="ipt"  placeholder="请输入图标名称" v-model="model4"   />
                            </div>                                            
                        </li>
                        <li>
                            <div class='list_title'>  <span class="cRed">*</span>排序 :</div> 
                            <div class="list_con">
                                <Input      type='text' class="ipt"  placeholder="请输入排序排序编号" v-model="model5"   />
                            </div>                                            
                        </li>
                        <li>
                            <div class='list_title'>  是否是按钮 :</div> 
                            <div class="list_con">
                             
                                <i-switch class='mSwitch' v-model="model6" @on-change="change_btn" />
                               
                            </div>                                            
                        </li>
                       
                    </ul>
                </Modal>
                <!-- 编辑弹窗 -->
                <Modal
                    v-model="modal2"
                    title="菜单编辑"
                  
                    class-name="vertical-center-modal"
                >
                    <div slot="footer">
                        <Button type='text' size='large' @click='cancel2'>取消</Button>
                        <Button type='primary' size='large' @click='ok2'>修改</Button>
                    </div>
                    <ul class="list_ul">
                        <!-- 当前 -->
                        <li> 
                            <div class='list_title'>  名称 :</div>
                            <div class="list_con">
                                <Input  disabled     type='text' class="ipt"  placeholder="请输入名称" v-model="model1"  />
                            </div>   
                        
                        </li>
                        <!-- 权限名称-->
                        <li>
                            <div class='list_title'>  权限名称 :</div> 
                            <div class="list_con">
                                <Input      type='text' class="ipt"  placeholder="请输入权限名称" v-model="model2"  />
                            </div>                                            
                        </li>
                        <!-- 控制器/方法 -->
                        <li>
                            <div class='list_title'>  控制器/方法 :</div> 
                            <div class="list_con">
                                <Input       type='text' class="ipt"  placeholder="请输入控制器/方法" v-model="model3"   />
                            </div>                                            
                        </li>
                        <!-- 图标名称 -->
                        <li>
                            <div class='list_title'>  图标名称 :</div> 
                            <div class="list_con">
                                <Input       type='text' class="ipt"  placeholder="请输入图标名称" v-model="model4"   />
                            </div>                                            
                        </li>
                        <li>
                            <div class='list_title'>  排序 :</div> 
                            <div class="list_con">
                                <Input       type='text' class="ipt"  placeholder="请输入排序编号" v-model="model5"   />
                            </div>                                            
                        </li>
                        <li>
                            <div class='list_title'>  是否是按钮 :</div> 
                            <div class="list_con">
                                <i-switch class='mSwitch' v-model="model6" @on-change="change_btn" />
                            </div>                                            
                        </li>
                       
                    </ul>
                </Modal>


              <!-- 确认删除框 -->
              <Modal
                v-model="delM"
                title="提示"
                @on-ok="delOk"
                @on-cancel="cancel"
                class-name="vertical-center-modal"
            >
                <p>确定删除吗?</p>
                
            </Modal>
          </div>

       </div>
       
  </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import { setTimeout } from 'timers';
   

    export default {
        name:'menus',
        data () {
            return {
                
                route: null,
                data_init:null,
                token:'',
               
                columns1:[],
                  
                data1:[],
                checkGuid2: null,
                del_num:0,
                checkGuid2:'',
                levels: -1,
                sort: '',           //匹配

                lv1: false,        //第一级是否被点击过
                lv1: false,         //第二级是否被点击过

                val: -1,

                // 添加弹窗
                add_select: [],
                modal1: false,
                modal2: false,
                titleList: [],    //列表内容

                model1_1: -1,   //父级的sort
                model1: null,   //父级
                model2: null,   //权限名称
                model3: null,   //控制器/方法
                model4: null,   //图标名称
                model5: null,   //排序
                model6: false,

                editorGuid:null,
              
                delM: false,   //是否删除
                guid: '' ,        //删除的guid

                resList:[],  //要删除的对象的guid
                dataAll:[],       //所有的data


                allShow: '全部显示',

                checks: []
            }
        },
       
        watch:{
            data1(val){
                // console.log(val);
                if( val.length == this.dataAll.length ){
                        this.allShow = '部分显示'
                }else if( val.length == this.data_init.length){
                     this.allShow = '全部显示'   
                     
                }else{
                    this.allShow = '全部显示'
                }
                
            }
           
           
          
        },
        computed: {
            is_change_layout(){
               return this.$store.getters.is_change_layout
            },
            is_change_image(){     
               return this.$store.getters.is_change_image
            },
            
        },
        methods: {
           load(){
                var that = this;
                that.$ajax({
                
                    method:'get',
                    url: 'admin/service/admin/all/menu',
                    data:{},
                   
                }).then(res => {
                    that.data_init = res.data.data;
                 
                    that.data1 = res.data.data;
                    // that.data_init = that.data_init_fun(res.data.data);
                  
                    // that.data1 = that.data_init;

                    // that.data1 = that.data_init.map(x=>x);
                    
                    that.columns1= [  
                    //   {type:'selection',align:'center',width:60},
                      {title:'图标',slot:'menuImage',align:'center',width:80},
                      {title:'权限名称',key:'title',minWidth: 120,ellipsis: true,tree:true},
                      {title:'控制器/方法',key:'url',minWidth: 120,ellipsis: true,render:(h,params) => {
                          return h('span',{ 
                            style:{
                               
                            },
                            domProps:{
                              title: params.row.url
                            }
                          },params.row.url)
                        }
                      },
                      {title:'验证权限',key:'isCheck',align:'center',width: 110,
                            render: (h, params) => {
                           
                              return h('i-switch', {
                                      
                                      props: {
                                          size: "large",
                                          value: params.row.isCheck == 0,
                                          
                                      },
                                      on: {
                                          'on-change': (value) => {
                                              let val;
                                              if(value){
                                                val = 0
                                              }else{
                                                val = 1
                                              }

                                              that.$myAjax.put('admin/service/admin/user/menu/check?route=/layout/jurisdiction/menu/editor',
                                                  {
                                                      "guid": params.row.guid,
                                                      "isCheck": val
                                                  },
                                                  
                                              ).then(res => {
                                                
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '开启'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '关闭'
                                          }
                                      }),
                                  ]
                              )
                            }

                      },
                      {title:'菜单状态',key:'isHide',align:'center',width: 110,
                          render: (h, params) => {
                           
                            return h('i-switch', {
                                    
                                    props: {
                                        size: "large",
                                        value: params.row.isHide == "0"
                                    },
                                    on: {
                                        'on-change': (value) => {
                                            let val;
                                            if(value){
                                              val = 0
                                            }else{
                                              val = 1
                                            }

                                            that.$myAjax.put('admin/service/admin/user/menu/hide?route=/layout/jurisdiction/menu/editor',
                                                {
                                                    "guid": params.row.guid,
                                                    "isHide": val
                                                },
                                               
                                            ).then(res => {
                                              that.$store.commit('change_layout', !that.$store.state.layout);
                                        
                                            }).catch(err=>{
                                                console.log(err)
                                            })


                                        }
                                    }
                                },
                                [h('span', {
                                        slot: "open",
                                        domProps: {
                                            innerHTML: '开启'
                                        }
                                    }),
                                    h('span', {
                                        slot: "close",
                                        domProps: {
                                            innerHTML: '关闭'
                                        }
                                    }),
                                ]
                            )
                          }
                      
                      },
                      {title:'排序',key:'sort',align:'center',width:80},
                    //   {title:'切换子菜单',slot:'changeList',align:'center',width:120},
                
                      {title:'操作',slot:'btn',align:'center',width: 180,fixed: 'right'}
                    ];

                    // 全部显示
                    var my_all = [{children:[]}];   //为了递归，加了一层children
                    my_all[0].children=that.data_init;
                    
                    that.dataAll = [];
                    
                    that.af(my_all[0]);
                    
                    
                    
                    let add_select = [];
                    add_select.push({guid: -1,title:'默认顶级'});
                    for(let v = 0; v < that.dataAll.length ; v++){
                        add_select.push({guid: that.dataAll[v].guid,title: that.dataAll[v].title})
                    }
                    that.add_select = add_select;
                    
                    // console.log(that.add_select)

                  
                })

              
           },
          
          //    是否是按钮
           change_btn(bool){

           },
        //    全部显示
           listAllFun(){
                let that = this;

                if( that.data1.length != that.dataAll.length ){
                     that.data1 = that.dataAll.map(x => x);         
                }else{
                    that.data1 = that.data_init.map(x => x);   
                }
              
           },

           

            //    添加弹窗
            ok1() {
                var that = this;
                var data;
                          
                var model6;
                if(that.model6){
                    model6 = 1
                }else{
                    model6 = 0
                }   
                if(that.checkGuid2 == -1){
                    that.checkGuid2 = null
                }    
                that.$ajax({
                
                    method:'post',
                    url: 'admin/service/admin/add/menu?route='+that.route,
                    data:{
                        superMenuGuid: that.checkGuid2,
                        menuName: that.model2,
                        url: that.model3,
                        menuImage: that.model4,
                        sort: that.model5,
                        isButton: model6
                       
                    },
                  
                }).then(res => {
                    that.load();
                    that.$alert.info(res);
                      
                    if(res.data.code == 1){
                        that.cancel1();
                    }
                    
                })
               
            },
            cancel1() {
                this.modal1 = false;

                this.model2 = null;
                this.model3 = null;
                this.model4 = null;
                this.model5 = null;
                this.model6 = false;
               
            },
            // 点击添加
            addFun(res,route){
                let that = this;
                
                
                that.$canBtn( that.route).then( function(res_c){
                    

                    that.modal1 = true;

                    if(res == -1){
                        that.checkGuid2  = -1;

                        that.model1   = '-1';
                        that.model2   = null;
                        that.model3   = null;
                        that.model4   = null;
                        that.model5   = null;
                        
                        that.model6 = false; 
                    }else{
                        that.checkGuid2  = res.guid;

                        that.model1   = res.title;
                        that.model2   = null;
                        that.model3   = null;
                        that.model4   = null;
                        that.model5   = null;
                        
                        that.model6 = false; 
                    }
                })
               
               
            },
          
            //   编辑弹窗
            ok2() {
                var that = this;
                var data;
                var model6;
                if(that.model6){
                    model6 = 1
                }else{
                    model6 = 0
                }          
                if(!that.model4){
                    that.model4 = null
                }
               
                that.$ajax({
                   
                    method:'put',
                    url: 'admin/service/admin/user/menu?route='+that.route,
                    data:{
                        guid: that.checkGuid2,
                        menuName: that.model2,
                        url: that.model3,
                        menuImage: that.model4,
                        sort: that.model5,
                        isButton: model6
                      
                    },
                   
                }).then(res => {
                    
                    that.editor_load(that.data1);   //刷新编辑
                    
                    // that.load();
                    that.$store.commit('change_layout', !that.$store.state.layout);
                    that.$alert.info(res);
                   
                    that.cancel2();

                   
                    
                })
            },
            cancel2() {
                this.modal2 = false;

                this.model2 = null;
                this.model3 = null;
                this.model4 = null;
                this.model5 = null;
                this.model6 = false;
            },

            

            // 菜单编辑
            editorFun(res,route){
                let that = this;
                

                that.$canBtn( that.route).then( function(res_c){
                   
                    that.modal2 = true;

                    that.model1 = res.menuName;
                    that.checkGuid2 = res.guid;
                    
                    that.model2   = res.menuName;
                    that.model3   = res.url;
                    that.model4   = res.menuImage;
                    that.model5   = res.sort;
                    if(res.isButton == 0){
                        that.model6 = false; 
                    }else{
                        that.model6 = true;
                    }
               
                }) 
                
                
            },
            
            // 删除菜单
            delFun(res,route){
                let that = this;
           

                that.$canBtn( that.route).then( function(res_c){
                 
                    that.delM = true;
                    that.checkGuid2 = res.guid;
                   
                })
            },
            delOk(){
                let that = this;
                
                if(that.del_num == 0){
                    that.$myAjax.delete(                  
                        'admin/service/admin/user/menu?guid='+that.checkGuid2+'&route='+that.route, 
                    ).then(res => {
                        that.del_load( that.data1);  //del刷新data1
                        that.$store.commit('change_layout', !that.$store.state.layout);
                    })
                }else if(that.del_num == 1){
                    that.$myAjax.post(                  
                        'admin/service/admin/user/menus?route='+that.route,
                        
                        that.checks 
                        
                        
                    ).then(res => {
                          that.load();
                        
                    })
                }
                    
            },
            cancel(){},
            listFun(res,index){
                let that = this;
                that.resList = [];
                if(res.children.length>0){
                    let bool = true;
                    for(let j = 0; j<that.data1.length;j++){

                        if(that.data1[j].guid === res.children[0].guid){
                           bool = false;        //  已展开
                        }
                    }
                    if(bool){
                        for(let i = res.children.length-1; i >= 0;i--){ 
                            
                            that.data1.splice(index+1,0,res.children[i]) 
                        }    
                    }else{
                        
                        that.bf(res);
                        // console.log(that.resList)
                        for(let i = 0; i < that.data1.length;i++){ 
                            for(let j = 0; j < that.resList.length;j++){ 
                                if(that.data1[i].guid == that.resList[j]){
                                    // console.log(that.data1[i].guid)
                                    that.data1.splice(i,1) 
                                }
                                
                            }
                        }    
                    }
                }
            },
            bf(res){
                let that = this;
                if( res.children.length>0 ){
                    for(let v=0;v<res.children.length;v++){
                        that.resList.push(res.children[v].guid);
                        that.bf(res.children[v]);
                        // console.log(that.resList)
                    }
                }
                
            },
            // 显示所有
            af(res){
                let that = this;
                if( res.children.length>0 ){
                    for(let i = 0 ; i <res.children.length;i++){             
                        that.dataAll.push(res.children[i]);
                        // console.log('完整列表',that.dataAll)
                        that.af(res.children[i]); 
                    }    
                   
                }     
                
            },
          

            // data_init_fun(data){
            //     let that = this;
            //     for (let i = 0; i < data.length; i++) {
            //         if (data[i].children) {
            //             that.data_init_fun(data[i].children)
            //         }
            //         for(let j = 0; j< data[i].level;j++){
            //             data[i].title = `|— ${data[i].title}`
            //         }
                        
            //     }
            //     return data
            // },
            // 刷新编辑
            editor_load(data){
                let that = this;
                
                for (let i = 0; i < data.length; i++) {
                    if (data[i].children) {
                        that.editor_load(data[i].children)
                    }
                    if( data[i].guid == that.checkGuid2 ){
                        
                        data[i].menuName = that.model2;
                        // let num = 0;
                        // for(let key in data[i].title){
                        //     if(key == "|"){
                        //         num += 1;
                        //     }    
                        // }
                        let num = data[i].level - 1;
                        data[i].title = that.model2;
                        for(let v = -1; v< num;v++){
                            data[i].title = "|— " +  data[i].title;
                        }
                        data[i].url = that.model3;
                        data[i].menuImage = that.model4;
                        data[i].sort = that.model5;
                        data[i].isButton = that.model6
                       
                    }
                        
                }
                return data   
            },
            // 刷新删除
            del_load(data){
                let that = this;
                for (let i = 0; i < data.length; i++) {
                    if (data[i].children) {
                        that.del_load(data[i].children);
                      
                       
                    }
                    if( data[i].guid == that.checkGuid2 ){
                       
                        data = data.splice(i,1)
                        
                    }
                        
                }
                return data   
            },
             //    选择
            checkFun(){
                let that = this;
                let checks = [];
                let list = that.$refs.table.getSelection();
                let len = list.length;
                for(let i =  0;i<len;i++){
                    checks.push(list[i].guid)
                }
                
                that.checks = checks;
                
            },
            
            
         
        },
       
        mounted: function(){
           var that = this;
           that.checkGuid = that.$store.state.checkGuid;
           that.token = that.$store.state.token;
           
           that.load();
           
            
        }
    }
</script>
<style scoped>
   @import "/css/modal.css";
   .nameW{
       
       width: 40%;
       
   }
    .nameW:first-child{
       margin-right: 20%; 
    }
    
    .select li{
        padding: 5px;
    }
    
</style>
